import React from 'react';

class Barbaros extends React.Component {
  render() {
    return (
      <div style={{ paddingTop: '2em', paddingBottom: '2em' }}>
        <img src="./img/svg/titulo.svg" alt="Bárbaros" />
      </div>
    );
  }
}

export default Barbaros;



// WEBPACK FOOTER //
// ./src/components/Barbaros.js